import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/styles';
import Card from '@mui/material/Card';
import SingleInfoBox from './SingleInfoBox';

import Divider from "@mui/material/Divider";
import EventCardButtons from './EventCardButtons';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { MixPanelTrackedLink } from '../../../components';

const eventDetails = [
  { label: 'Event', value: 'Marathon' },
  { label: 'Event Starts At', value: '02/02/2023 | 4:30 PM' },
  { label: 'Timezone', value: '[GMT+5] Karachi, Pakistan' },
  { label: 'Location', value: 'Gaddafi Stadium' },
  { label: 'Status', value: 'Event has Ended' },
]

const mapDetails = () => {
  return eventDetails.map(detail => {
    return <SingleInfoBox label={detail.label} value={detail.value} />
  })
}

export default function EventDetailsCard() {
  return (
    <StyledEventCard>
      <Card>
        <CardContent>
          <EventCardButtons />
          <Divider />
          {mapDetails()}
        </CardContent>
        <CardActions>
          <MixPanelTrackedLink
            type="button"
            label="Share the Event"
            context="Event details page"
            variant="outlined"
            color="neutral"
            fullWidth
          >
            Share the Event
          </MixPanelTrackedLink>
        </CardActions>
      </Card>
    </StyledEventCard>
  );
}

const StyledEventCard = styled(Box)(({ theme }) => ({
  '& .MuiCard-root': {
    borderRadius: '15px', 
    boxShadow: '0 0.3125rem 1rem -0.1875rem rgb(0 0 0 / 30%)', 
    padding: '1rem'
  },

}));